export const SENIORITY_LABELS: Record<string, string> = {
  '1': 'Board Member / Company Director',
  '2': 'Owner / Founder',
  '3': 'C-Suite / Partner',
  '4': 'VP/Director / Head of',
  '5': 'Manager',
  '6': 'Other',
  '7': 'No data available',
};

export const DEPARTMENT_LABELS: Record<string, string> = {
  '1': 'General Management',
  '2': 'Sales',
  '3': 'Trades',
  '4': 'Operations',
  '5': 'Engineering & Technical',
  '6': 'Human Resources',
  '7': 'Customer Service',
  '8': 'Medicine & Healthcare',
  '9': 'Research & Analysis',
  '10': 'Legal',
  '11': 'Marketing',
  '12': 'Education & Training',
  '13': 'Consulting',
  '14': 'Finance',
  '15': 'Product',
  '16': 'Other',
  '17': 'No data available',
};
